import API_BASE from "../config";

// New in 2026-05-20: two-phase create flow. When the project already
// exists (metadata was saved by /projects POST earlier), call
// /projects/{id}/sketch with just the geometry payload — skips
// create_project on the backend. Returns the same shape as the legacy
// /submit so the caller doesn't care which endpoint ran.
export const submitSketchData = async (projectId, { geometries, projectDetails, mastLayout }) => {
  const { fieldRectangle, mastArrows, mastPoints, buildingPolylines, buildingHeights } = geometries || {};
  const response = await fetch(`${API_BASE}/projects/${projectId}/sketch`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      geometries: { fieldRectangle, mastArrows, mastPoints, buildingPolylines, buildingHeights },
      projectDetails,
      mastLayout,
    }),
  });
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Failed to sketch project: ${errorText}`);
  }
  return await response.json();
};

export const submitProjectData = async ({ geometries, projectDetails, mastLayout }) => {
  try {
    const {
      fieldRectangle,
      mastArrows,
      mastPoints,
      buildingPolylines,
      // Gebaeudehoehen aus der Tabelle in Schritt 5, index-parallel zu
      // buildingPolylines. Fehlt das Feld (aelterer Frontend-Stand), setzt
      // das Backend weiter seine 8 m.
      buildingHeights,
    } = geometries || {};

    const response = await fetch(`${API_BASE}/submit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        geometries: {
          fieldRectangle,
          mastArrows,
          mastPoints,
          buildingPolylines,
          buildingHeights,
        },
        projectDetails,
        mastLayout,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to submit data: ${errorText}`);
    }

    const result = await response.json();
    console.log("Data submitted successfully:", result);
    return result;
  } catch (error) {
    console.error("Error submitting project data:", error);
    throw error;
  }
};

export const submitProjectDataTest = async ({ geometries, projectDetails, mastLayout }) => {
  try {
    const {
      fieldRectangle,
      mastArrows,
      mastPoints,
      buildingPolylines,
      // Gebaeudehoehen aus der Tabelle in Schritt 5, index-parallel zu
      // buildingPolylines. Fehlt das Feld (aelterer Frontend-Stand), setzt
      // das Backend weiter seine 8 m.
      buildingHeights,
    } = geometries || {};

    const response = await fetch(`${API_BASE}/testprojectcalculation`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        geometries: {
          fieldRectangle,
          mastArrows,
          mastPoints,
          buildingPolylines,
          buildingHeights,
        },
        projectDetails,
        mastLayout,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to submit data: ${errorText}`);
    }

    const result = await response.json();
    console.log("Data submitted successfully:", result);
    return result;
  } catch (error) {
    console.error("Error submitting project data:", error);
    throw error;
  }
};
